import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function emailIsValid(email) {
    return /\S+@\S+\.\S+/.test(email)
}

export default class RoleAndUserNewUserDialog extends React.Component {
    state = {
        open: false,
        title: 'New User',
        message: null,
        user: {},
        callBack: null
    };

    show(callBack) {
        this.setState({ open: true, user: {}, callBack: callBack });
    }

    handleOk = () => {
        this.setState({ open: false });
        if (this.state.callBack) {
            this.state.callBack(this.state.user);
        }
    };

    handleClose = () => {
        this.setState({ open: false });
    };
    
    render() {
        const { user } = this.state;
        return (
            <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {this.state.message}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        error={!user.userName}
                        margin="dense"
                        value={user.userName}
                        onChange={e => {
                            user.userName = e.target.value;
                            this.setState({ user });
                        }}
                        id="name"
                        label="User Name"
                        helperText={!user.userName? 'Please type user name':''}
                        type="text"
                        fullWidth
                    />
                    <TextField
                        error={!emailIsValid(user.email)}
                        margin="dense"
                        value={user.email}
                        onChange={e => {
                            user.email = e.target.value;
                            this.setState({ user });
                        }}
                        id="name"
                        label="Email"
                        helperText={!emailIsValid(user.email)?'Please type valid email':''}
                        type="text"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
            </Button>
                    <Button disabled={!user.userName || !emailIsValid(user.email)}
                        onClick={this.handleOk} color="primary">
                        Ok
            </Button>
                </DialogActions>
            </Dialog>
        );
    }
}